<template>
  <v-card class="elevation-12" color="grey darken-4" dark>
    <v-card-text>
      <v-row>
        <v-col class="d-flex justify-center">
            <v-img src="/img/logo.png" contain max-width="240"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-alert
            :value="message"
            type="error"
            dismissible
            transition="scale-transition"
            v-if="message"
          >{{ message}}</v-alert>
        </v-col>
      </v-row>
      <v-form>
        <v-row>
          <v-col>
            <v-text-field prepend-icon="mdi-account" v-model="username" label="Login" type="text"/>
            <v-text-field
              id="password"
              prepend-icon="mdi-lock"
              v-model="password"
              label="Password"
              type="password"
            />
          </v-col>
        </v-row>
        
      </v-form>
    </v-card-text>
    <v-card-actions class="flex-wrap justify-end px-4 pb-4">
      <v-btn text class="text-caption ma-1" to="/forgot-password">Forgot password ?</v-btn>
      <v-btn outlined color="accent" class="ma-1" @click="doLogin()">Login</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { MIDDLEWARE_REACT } from "@/config";

export default {
  data: () => ({
    username: null,
    password: null,
    message: null,
  }),
  computed: {
    ...mapGetters('auth', ['loading'])
  },
  methods: {
    ...mapActions('auth', ['login']),
    doLogin() {
      this.message=null
      this.login({
        username: this.username,
        password: this.password
      })
        // Le dashboard vit dans l'app React (/v2) : changement d'app, donc
        // navigation complète. Le cookie id_token est partagé (path=/).
        .then(() => { window.location.href = MIDDLEWARE_REACT + "dashboard" })
        .catch((err) => {
          this.message = err.message
        });
    }
  }
};
</script>

<style></style>
